<template>
  <div>
    <cheque-tabs v-if="$route.name == 'ChequesList'" :type="isPaid"></cheque-tabs>
    <v-card class="white rounded-lg">
      <v-card-title class="secondary--text">{{ title }}
        <v-spacer></v-spacer>
        <v-autocomplete
            style="width: 1px"
            label="وضعیت چک"
            class="mr-16 rounded-lg"
            :items="cheque_types"
            item-text="text"
            item-value="value"
            v-model="cheque_type"
            @change="changeType()"
        >
        </v-autocomplete>
      </v-card-title>
      <v-card-text>
        <m-datatable
            :headers="headers"
            :apiUrl="url"
            :filters.sync="filters"
            ref="datatable"
            @dblclick:row="(e, row) => $router.push(to(row.item))"
        >
          <template #item.remain="{ item }">{{ getRemain(item) | toMoney }}</template>
          <template #item.settle="{ item }">
            <v-btn color="info white--text" :to="toSettle(item)" text>تسویه</v-btn>
          </template>
          <template #item.detail="{ item }">
            <detail-link :to="to(item)"/>
          </template>
        </m-datatable>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import QueryBinding from "@/components/m-query-binding";
import ChequeMixin from "@/views/panel/cheque/mixin";
import ChequeTabs from "@/views/panel/cheque/ChequeTabs";
import {toString} from "lodash";

export default {
  name: "ChequesList",
  components: {ChequeTabs},
  mixins: [QueryBinding, ChequeMixin],
  props: {
    type: {
      require: true,
    },
    isPaid: {
      require: true,
    },
  },
  data() {
    return {
      filters: {
        type: this.type,
        is_paid: this.isPaid,
      },
      url: "reports/lists/cheques",
      cheque_type: "all",
    };
  },
  computed: {
    cheque_statuses() {
      let cheque_status = []
      for (let status of this.chequeStatuses){
        if(toString(this.isPaid) == 'true'){
          if(status.value != 'transferred'  && status.value != 'extended' && status.value != 'inFlow') {
            cheque_status.push(status)
          }
        } else if (toString(this.isPaid) == 'false') {
          if(status.value != 'extended' ) {
            cheque_status.push(status)
          }
        }
      }
      return cheque_status
    },


    cheque_types() {
      let cheque_types = [
        {text: 'همه چک ها', value: 'all'},
      ]

      for( let type of this.cheque_statuses){
        cheque_types.push(type)
      }
      cheque_types.push({text: 'چک های سررسید گذشته', value: 'duePassed'})
      cheque_types.push({text: 'چک های برگشتی سررسید گذشته', value: 'duePassedAndBounced'})

      return cheque_types
    },
    title() {
      switch (toString(this.isPaid)) {
        case 'false':
          return this.setDocumentTitle("لیست چک های دریافتنی")
        case 'true':
          return this.setDocumentTitle(" لیست چک های پرداختنی")
      }
    },
    headers() {
      let headers = [
        {
          text: (toString(this.isPaid) == 'true')? 'پرداخت به':'دریافت از',
          value: "account.name",
        },
        {
          text: (toString(this.isPaid) == 'true')? 'سریال چک':'شماره چک',
          value: "serial",
        },
      ];
      if (toString(this.isPaid) == 'true'){
        headers.push({
          text: "شماره سری",
          value: "chequebook.serial",
        });
      }
      headers.push(
          {
            text: "تاریخ ثبت",
            value: "date",
            type: "date",
          },
          {
            text: "تاریخ سررسید",
            value: "due",
            type: "date",
          },
          {
            text: "مبلغ",
            value: "value",
            type: "numeric",
          },
          {
            text: "شرح",
            value: "explanation",
          },

          {
            text: "وضعیت",
            value: "status",
            items: this.cheque_statuses,
            width: '100px',
          },
          {
            text: "نام بانک",
            value: "bankName",
          },
      );
      headers.push({
        text: "جزئیات",
        value: "detail",
        sortable: false,
        filterable: false,
      });

      return headers;
    },
  },
  created() {
    this.getChequeMeta();
  },
  mounted() {
    this.updateFilters();
  },
  watch: {
    $route() {
      this.updateFilters();
      this.$refs.datatable.getDataFromApi();
    },
    isPaid() {
      this.cheque_type = 'all'
    }
  },
  methods: {
    updateFilters() {
      try {
        this.filters = {...JSON.parse(this.$route.query.filters)};
      } catch {
        this.filters = {};
      }
      this.filters["is_paid"] = this.isPaid;
      this.filters["type"] = this.type;
    },

    getRemain(item) {
      let remain = item.sanad.bed;
      if (item.imprestSettlement) {
        remain -= item.imprestSettlement.settled_value;
      }
      return remain;
    },
    to(item) {
      return {
        name: "ChequeDetail",
        params: {
          type: this.type,
          id: item.id,
        },
      };
    },
    changeType() {
      this.filters = {type: this.type, is_paid: this.isPaid,}
      if (this.cheque_type == 'bounced'){
        this.filters['status'] = 'bounced'
      }
      if (this.cheque_type == 'notPassed'){
        this.filters['status'] = 'notPassed'
      }
      else if (this.cheque_type == 'duePassed'){
        this.filters['due__lt'] = this.serverNow ? this.serverNow.format("YYYY-MM-DD") : ""
      }
      else if (this.cheque_type == 'blank'){
        this.filters['status'] = 'blank'
      }
      else if (this.cheque_type == 'duePassedAndBounced'){
        this.filters['status'] = 'bounced'
        this.filters['due__lt'] = this.serverNow ? this.serverNow.format("YYYY-MM-DD") : ""
      } else{
        this.filters['status'] = this.cheque_type
      }
      this.$refs.datatable.getDataFromApi()
    },

  },
};
</script>

<style scoped lang="scss"></style>
